
import React from 'react';

const GradientBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Top gradient */}
      <div className="absolute top-0 left-1/4 w-1/2 h-96 bg-blue-600 rounded-full opacity-20 blur-[100px] transform -translate-y-1/2" />
      
      {/* Bottom right gradient */}
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-500 rounded-full opacity-20 blur-[100px] transform translate-y-1/4" />
      
      {/* Bottom left gradient */}
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-600 rounded-full opacity-20 blur-[100px] transform translate-y-1/4" />
    </div>
  );
};

export default GradientBackground;
